<ion-header>
  <ion-toolbar class="modal-header">
    <h3>{{ title }}</h3>
    <ion-buttons slot="end">
      <ion-button role="button" class="text-base" (click)="dismiss()">
        <ion-icon name="close" aria-hidden="true"></ion-icon>
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="modal-content custom-modal">
  <div class="flex flex-col [&>*]:w-full  mx-auto p-4">
    <p class="mt-2" [innerHTML]="message"></p>
    <div class="flex flex-col gap-3 md:flex-row">
      <ng-container *ngFor="let button of buttons">
        <ion-button role="button"
          [class]="button.cssClass || 'tertiaryBtn'"
          [fill]="button.fill || 'outline'"
          [color]="button.color"
          expand="block"
          class="flex-1"
          (click)="handleButtonClick(button)">
            {{ button.text }}
        </ion-button>
      </ng-container>
    </div>
  </div>
</ion-content>